import React, { useEffect, useState } from 'react';
import HeaderFFF from '../../../components/HeaderFFF'
import Header from '../../../components/Header'
import Footer from "../../../components/Footer";
import { Link } from 'react-router-dom';
import '../../../styles/injury.css'

export default function WrongfulDeath() {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000);
    
        useEffect(() => {
            const handleResize = () => {
                setIsMobile(window.innerWidth <= 991);
            };
    
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }, []);
    
        return(
            <>
            {isMobile ? <Header /> : <HeaderFFF />}
        <div id="injury">
            <div id="fields-header-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                    <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
                </svg>
                <h2>Wrongful Death</h2>
                <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                    <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </div>
            <div className="pi-go-back">
                        <Link to="/fields-of-expertise/personal-injury">Take me back</Link>
            </div>
            <div className="pi-text">
                <p>Nothing is more devastating than experiencing the <b>wrongful death</b> of a loved one. There is
nothing that can make up for such a tragedy. When accidents take a life, families are left
distraught and irreversibly harmed.<br/><br/>
Unfortunately, the suffering does not stop there. Medical costs, funeral expenses, therapy fees,
and loss of income can all financially ruin the family of the deceased. It is an unfortunate reality
that death often carries a significant financial cost. Families often struggle for years with the
financial consequences and suffer undue harm.<br/><br/>
This is why it is important for families to receive compensation when a <b>wrongful death</b> occurs.
Compensation can help cover funeral expenses, medical costs, and therapy fees. While it
cannot ease the pain of a death, it can at least help families keep from suffering any more than
necessary.<br/><br/>
<span className="pi-sub-section">Wrongful Death Lawsuit Settlements</span><br/><br/>
The law is complex when it comes to wrongful death and compensation can vary greatly.
A <Link to="/our-team/mick-vashishth">personal injury lawyer</Link> can help you navigate the law and secure compensation to help you
handle a wrongful death in the family.<br/><br/>
CLV understands that if you’ve experienced the wrongful death of a loved one, you need to
focus on your well-being and not on legal issues. Let us handle your case and secure the
compensation you need during this difficult time. Our goal is to help you and your family through
this difficult experience. We are equipped to handle complex legal and insurance issues arising
from your accident and we take the utmost care and patience when working with those who
have experienced a wrongful death.<br/><br/>
At CLV we have helped recover losses caused by the wrongful death of a loved one. We have
brought those responsible to justice, providing our clients the opportunity to heal. We take these

cases very seriously and do everything we can to get our clients the resolution they deserve.<br/><br/>
If you have recently lost a loved one, <Link to="/contact-us">contact</Link> our dedicated and compassionate legal team at CLV.</p>
            </div>
        </div>
            <Footer />
        </>
        );
}